import {Patient} from "../app/_models";


export function setUser(user) {
    if (!user) {
        localStorage.removeItem('currentUser');
    } else {
        localStorage.setItem('currentUser', JSON.stringify(user));
    }
}

export function getUser() {
    if (localStorage.getItem('currentUser')) {
        return JSON.parse(localStorage.getItem('currentUser'));
    } else {
        return false;
    }
}

export function setToken(token) {
    if (!token) {
        localStorage.removeItem('token');
    } else {
        localStorage.setItem('token', token);
    }
}

export function getToken() {
    return localStorage.getItem('token');
}


export function isUserConnected() {
    if (localStorage.getItem('currentUser')) {
        return true;
    } else {
        return false;
    }
}

export function setCurrentAbeille(abeille) {
    localStorage.setItem('currentAbeille', JSON.stringify(abeille));
}

export function getCurrentAbeille() {
    if (localStorage.getItem('currentAbeille')) {
        return JSON.parse(localStorage.getItem('currentAbeille'));
    } else {
        return false;
    }
}

export function setCurrentRole(role) {
    localStorage.setItem('currentRole', role);
}

export function getCurrentRole() {
    return localStorage.getItem('currentRole');
}
